import { authenticationService } from "services";
import { authenticationConstants } from "../constants";

export const authenticationActions = {
  registerDevice,
  authenticateDevice,
  getOrganizationDetails,
  getOrganizationLogo,
};

function registerDevice(deviceId, browserType, browserInfo, appCode, orgCode) {
  return (dispatch) => {
    dispatch(request());

    authenticationService
      .registerDevice(deviceId, browserType, browserInfo, appCode, orgCode)
      .then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(error))
      );
  };

  function request() {
    return { type: authenticationConstants.REGISTER_REQUEST };
  }
  function success(response) {
    return { type: authenticationConstants.REGISTER_SUCCESS, response };
  }
  function failure(error) {
    return { type: authenticationConstants.REGISTER_FAILURE, error };
  }
}

function authenticateDevice(refreshToken) {
  return (dispatch) => {
    dispatch(request());

    authenticationService.authenticateDevice(refreshToken).then(
      (response) => {
        dispatch(
          updateOrgDataOnSuccess({
            ...response,
            data: { ...response?.data?.organization },
          })
        );
        return dispatch(success(response));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: authenticationConstants.AUTHENTICATE_REQUEST };
  }
  function success(response) {
    return { type: authenticationConstants.AUTHENTICATE_SUCCESS, response };
  }
  function failure(error) {
    return { type: authenticationConstants.AUTHENTICATE_FAILURE, error };
  }
  function updateOrgDataOnSuccess(response) {
    return { type: authenticationConstants.ORGANIZATION_SUCCESS, response };
  }
}

function getOrganizationDetails() {
  return (dispatch) => {
    dispatch(request());

    authenticationService.getOrganizationDetails().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: authenticationConstants.ORGANIZATION_REQUEST };
  }
  function success(response) {
    return { type: authenticationConstants.ORGANIZATION_SUCCESS, response };
  }
  function failure(error) {
    return { type: authenticationConstants.ORGANIZATION_FAILURE, error };
  }
}

function getOrganizationLogo() {
  return (dispatch) => {
    dispatch(request());

    authenticationService.getOrganizationLogo().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: authenticationConstants.ORGANIZATION_LOGO_REQUEST };
  }
  function success(response) {
    return { type: authenticationConstants.ORGANIZATION_LOGO_SUCCESS, response };
  }
  function failure(error) {
    return { type: authenticationConstants.ORGANIZATION_LOGO_FAILURE, error };
  }
}
